import { EnhancedSelectOption, SelectOption } from '../types';
import { Ref, computed, ref, watch } from 'vue';

export type TIssuingMethod = 'NOMAL' | 'ONE' | 'OFFLINE' | 'MASTER_EXPRESS' | 'MASTER_CONSIGNED' | 'WAREHOUSE_PROXY'|'TRANSFER';
export type TDeliveryAddressType = 'CONTRACT' | 'OTHER';
export type TDeliveryAreaType = 'SALE_AREAS' | 'ALL';
export type TtmsDeliveryMethod = 'HOME_DELIVERY' | 'PICK_UP' | 'LOGISTICS';
export type warehouseDeliveryType = 'OVER_ALL' | 'PARTS_AND_ALL';
export type goodsTagsType ='ALLOC_ITEM'|'NO_DELIVERY'|'ASSEMBLY_ITEM'|'EXAMINE'|'OUT_OF_STOCK'|'FREE'|'CUSTOMER_DEMAND_NO_DIRECT'|'CUSTOMER_DEMAND_DIRECT'

export const useProxyDelivery = (ariesIssuingMethodEnum: Ref<TIssuingMethod>) => {
  const shipMap: Record<TIssuingMethod, EnhancedSelectOption<TtmsDeliveryMethod>[]> = {
    NOMAL: [
      {
        name: 'HOME_DELIVERY',
        displayName: '送货上门',
        label: '送货上门',
        value: 'HOME_DELIVERY'
      },
      {
        name: 'PICK_UP',
        displayName: '自提',
        label: '自提',
        value: 'PICK_UP'
      },
      {
        name: 'LOGISTICS',
        displayName: '物流',
        label: '物流',
        value: 'LOGISTICS'
      }
    ],
    TRANSFER: [
      {
        name: 'HOME_DELIVERY',
        displayName: '送货上门',
        label: '送货上门',
        value: 'HOME_DELIVERY'
      },
      {
        name: 'PICK_UP',
        displayName: '自提',
        label: '自提',
        value: 'PICK_UP'
      },
      {
        name: 'LOGISTICS',
        displayName: '物流',
        label: '物流',
        value: 'LOGISTICS'
      }
    ],
    ONE: [
      {
        name: 'LOGISTICS',
        displayName: '物流',
        label: '物流',
        value: 'LOGISTICS'
      }
    ],
    OFFLINE: [
      {
        name: 'LOGISTICS',
        displayName: '物流',
        label: '物流',
        value: 'LOGISTICS'
      }
    ],
    MASTER_EXPRESS: [
      {
        name: 'LOGISTICS',
        displayName: '物流',
        label: '物流',
        value: 'LOGISTICS'
      }
    ],
    MASTER_CONSIGNED: [
      {
        name: 'HOME_DELIVERY',
        displayName: '送货上门',
        label: '送货上门',
        value: 'HOME_DELIVERY'
      },
      {
        name: 'PICK_UP',
        displayName: '自提',
        label: '自提',
        value: 'PICK_UP'
      }
    ],
    WAREHOUSE_PROXY: [
      {
        name: 'HOME_DELIVERY',
        displayName: '送货上门',
        label: '送货上门',
        value: 'HOME_DELIVERY'
      }
    ]
  };

  const addressTypeMap: Record<TIssuingMethod, EnhancedSelectOption<TDeliveryAddressType>[]> = {
    NOMAL: [
      {
        name: 'CONTRACT',
        displayName: '合同地址',
        label: '合同地址',
        value: 'CONTRACT'
      }
    ],
    TRANSFER: [
      {
        name: 'CONTRACT',
        displayName: '合同地址',
        label: '合同地址',
        value: 'CONTRACT'
      }
    ],
    ONE: [
      {
        name: 'OTHER',
        displayName: '其他地址',
        label: '其他地址',
        value: 'OTHER'
      }
    ],
    OFFLINE: [
      {
        name: 'OTHER',
        displayName: '其他地址',
        label: '其他地址',
        value: 'OTHER'
      }
    ],
    MASTER_EXPRESS: [
      {
        name: 'CONTRACT',
        displayName: '合同地址',
        label: '合同地址',
        value: 'CONTRACT'
      },
      {
        name: 'OTHER',
        displayName: '其他地址',
        label: '其他地址',
        value: 'OTHER'
      }
    ],
    MASTER_CONSIGNED: [
      {
        name: 'CONTRACT',
        displayName: '合同地址',
        label: '合同地址',
        value: 'CONTRACT'
      },
      {
        name: 'OTHER',
        displayName: '其他地址',
        label: '其他地址',
        value: 'OTHER'
      }
    ],
    WAREHOUSE_PROXY: [
      {
        name: 'CONTRACT',
        displayName: '合同地址',
        label: '合同地址',
        value: 'CONTRACT'
      },
      {
        name: 'OTHER',
        displayName: '其他地址',
        label: '其他地址',
        value: 'OTHER'
      }
    ]
  };

  const sendAreaOptions: EnhancedSelectOption<TDeliveryAreaType>[] = [
    {
      name: 'SALE_AREAS',
      displayName: '所在销售区域',
      label: '所在销售区域',
      value: 'SALE_AREAS'
    },
    {
      name: 'ALL',
      displayName: '全国',
      label: '全国',
      value: 'ALL'
    }
  ];

  const warehouseDeliveryTypeOptions: SelectOption<warehouseDeliveryType>[] = [
    {
      label: '整件',
      value: 'OVER_ALL'
    },
    {
      label: '整散件',
      value: 'PARTS_AND_ALL'
    }
  ];
  
  
  const  goodsTagsTypeEnum:SelectOption<goodsTagsType>[] = [
    {

      label: '分配品',
      value: 'ALLOC_ITEM'
    },
    {

      label: '暂不发货',
      value: 'NO_DELIVERY'
    },
    {

      label: '子母件',
      value: 'ASSEMBLY_ITEM'
    },
    {

      label: '考核',
      value: 'EXAMINE'
    },
    {

      label: '缺货',
      value: 'OUT_OF_STOCK'
    },
    {

      label: '免费',
      value: 'FREE'
    },
    {

      label: '客需（非直发）',
      value: 'CUSTOMER_DEMAND_NO_DIRECT'
    },
    {

      label: '客需（直发）',
      value: 'CUSTOMER_DEMAND_DIRECT'
    }
  ] 



  const deliveryAddressTypeEnum = ref<TDeliveryAddressType>('CONTRACT');
  const deliveryAreaTypeEnum = ref<TDeliveryAreaType>('SALE_AREAS');
  const tmsDeliveryMethod = ref<TtmsDeliveryMethod>('HOME_DELIVERY');
  const addressTypeOptions = computed(() => addressTypeMap[ariesIssuingMethodEnum.value] ?? []);
  const pickerShippingType = computed(() => shipMap[ariesIssuingMethodEnum.value] ?? []);
  const showCustomAddress = computed(() => deliveryAddressTypeEnum.value === 'OTHER');
  const sendAreaDisabled = computed(() => !['MASTER_CONSIGNED'].includes(ariesIssuingMethodEnum.value as string));
  const tips = computed(() => {
    if (
      ['MASTER_EXPRESS', 'MASTER_CONSIGNED'].includes(ariesIssuingMethodEnum.value) &&
      deliveryAddressTypeEnum.value === 'OTHER'
    ) {
      return '（若超出省区范围不享受促销让利）';
    }
    return '';
  });
  const showAgree = computed(() => {
    return (
      ['OFFLINE', 'WAREHOUSE_PROXY'].includes(ariesIssuingMethodEnum.value) ||
      (['MASTER_EXPRESS', 'MASTER_CONSIGNED'].includes(ariesIssuingMethodEnum.value) &&
        deliveryAddressTypeEnum.value === 'OTHER')
    );
  });

  watch(
    ariesIssuingMethodEnum,
    (val) => {
      if (['NOMAL', 'OFFLINE', 'ONE', 'MASTER_CONSIGNED', 'WAREHOUSE_PROXY'].includes(val)) {
        deliveryAreaTypeEnum.value = 'SALE_AREAS';
      } else {
        deliveryAreaTypeEnum.value = 'ALL';
      }

      if (['NOMAL', 'MASTER_CONSIGNED', 'WAREHOUSE_PROXY'].includes(val as string)) {
        tmsDeliveryMethod.value = 'HOME_DELIVERY';
      } else {
        tmsDeliveryMethod.value = 'LOGISTICS';
      }

      if (['ONE', 'OFFLINE'].includes(val)) {
        deliveryAddressTypeEnum.value = 'OTHER';
      } else {
        deliveryAddressTypeEnum.value = 'CONTRACT';
      }
    },
    {
      immediate: true
    }
  );

  return {
    // 配送至
    deliveryAddressTypeEnum,
    // 交货方式选项
    pickerShippingType,
    // 交货方式
    tmsDeliveryMethod,
    // 配送范围
    deliveryAreaTypeEnum,
    // 配送范围是否禁用
    sendAreaDisabled,
    // 配送范围选项
    sendAreaOptions,
    // 配送至选项
    addressTypeOptions,
    // 是否显示自定义地址
    showCustomAddress,
    // 自定义地址提示
    tips,
    // 是否展示协议
    showAgree,
    // 整散件选项
    warehouseDeliveryTypeOptions,
    //分配品包含不包含
    goodsTagsTypeEnum
  };
};
